import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import SuccessPyramidAmina from '../components/SuccessPyramidAmina';
import Services from '../components/Services';
import Founder from '../components/Founder';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import TrademarkRegistrations from '../components/TrademarkRegistrations';
import { HOME_SCROLL_TARGET_KEY, scrollHomeSectionIntoView } from '@/lib/scrollHomeSection';
const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== '/') return;

    const fromStorage = sessionStorage.getItem(HOME_SCROLL_TARGET_KEY);
    if (fromStorage) {
      sessionStorage.removeItem(HOME_SCROLL_TARGET_KEY);
      const id = fromStorage;
      requestAnimationFrame(() => {
        setTimeout(() => scrollHomeSectionIntoView(id), 80);
      });
      return;
    }

    const hash = location.hash?.replace(/^#/, '');
    if (hash) {
      requestAnimationFrame(() => {
        setTimeout(() => scrollHomeSectionIntoView(hash), 80);
      });
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen w-full min-w-0 max-w-full overflow-x-hidden">
      <Header />
      <Hero />
      <About />
      <SuccessPyramidAmina />
      <Services />
      <Founder />
      <Contact />
      <TrademarkRegistrations />
      <Footer />
    </div>
  );
};

export default Home;
